import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/apiClient";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { Plus, Trash2, Building2, User } from "lucide-react";
import { toast } from "sonner";

export default function FieldCatalogManager() {
  const [departamentos, setDepartamentos] = useState([]);
  const [solicitantes, setSolicitantes] = useState([]);

  const load = () => api.get("/catalogs").then((r) => {
    setDepartamentos(r.data.departamentos || []);
    setSolicitantes(r.data.solicitantes || []);
  });
  useEffect(() => { load(); }, []);

  const add = async (tipo, value) => {
    const v = (value || "").trim();
    if (!v) return;
    try {
      const { data } = await api.post("/catalogs/field", { tipo, value: v });
      setDepartamentos(data.departamentos || []);
      setSolicitantes(data.solicitantes || []);
      toast.success("Agregado");
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo agregar"); }
  };

  const remove = async (tipo, value) => {
    try {
      const { data } = await api.delete("/catalogs/field", { data: { tipo, value } });
      setDepartamentos(data.departamentos || []);
      setSolicitantes(data.solicitantes || []);
      toast.success("Eliminado");
    } catch (err) { toast.error(err.response?.data?.detail || "No se pudo eliminar"); }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-testid="field-catalog-manager">
      <FieldList tipo="departamento" title="Departamentos solicitantes" icon={Building2} items={departamentos} onAdd={add} onRemove={remove} />
      <FieldList tipo="solicitante" title="Solicitantes" icon={User} items={solicitantes} onAdd={add} onRemove={remove} />
    </div>
  );
}

function FieldList({ tipo, title, icon: Icon, items, onAdd, onRemove }) {
  const [draft, setDraft] = useState("");
  const go = () => { onAdd(tipo, draft); setDraft(""); };
  return (
    <div className="border border-border bg-white rounded-sm p-6" data-testid={`field-catalog-${tipo}`}>
      <h3 className="font-heading font-bold text-lg flex items-center gap-2 mb-1"><Icon className="h-5 w-5" />{title}</h3>
      <p className="text-sm text-slate-500 mb-4">Estas opciones aparecen en los combos de Desarrollos y Solicitudes.</p>
      <div className="flex items-center gap-2 mb-3">
        <Input value={draft} onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); go(); } }}
          placeholder={`Nuevo ${tipo}...`} className="rounded-sm h-9" data-testid={`field-${tipo}-input`} />
        <Button onClick={go} variant="outline" className="rounded-sm h-9" data-testid={`field-${tipo}-add`}><Plus className="h-4 w-4 mr-1" />Agregar</Button>
      </div>
      <div className="space-y-1.5 max-h-[360px] overflow-y-auto pr-1">
        {items.length === 0 ? (
          <p className="text-sm text-slate-400">Sin registros.</p>
        ) : items.map((it) => (
          <div key={it} className="flex items-center justify-between border border-slate-100 rounded-sm px-3 py-1.5" data-testid={`field-${tipo}-item-${it}`}>
            <span className="text-sm text-slate-700 truncate" title={it}>{it}</span>
            <button onClick={() => onRemove(tipo, it)} className="text-slate-300 hover:text-red-600 shrink-0" title="Eliminar" data-testid={`field-${tipo}-del-${it}`}>
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
